export const getHubSpotConversationsClient = () => {
  return window.HubSpotConversations;
};